import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const SiteContentContext = createContext({ content: {}, t: (_, fb) => fb, reload: () => {} });

export function SiteContentProvider({ children }) {
  const [content, setContent] = useState({});

  const reload = useCallback(async () => {
    try {
      const { data } = await api.get("/public/site-content");
      setContent(data.content || {});
    } catch {
      // Network/offline - keep last known map (likely empty); JSX fallbacks will render
    }
  }, []);

  useEffect(() => { reload(); }, [reload]);

  const t = useCallback((key, fallback = "") => {
    const v = content[key];
    return v && v.length > 0 ? v : fallback;
  }, [content]);

  return (
    <SiteContentContext.Provider value={{ content, t, reload }}>
      {children}
    </SiteContentContext.Provider>
  );
}

export function useSiteContent() {
  return useContext(SiteContentContext);
}
